import { useState, useEffect } from 'react'

import styles from './FadeCarousel.module.scss'

const FadeCarousel = ({ items, interval = 3000 }) => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % items.length)
    }, interval)
    return () => clearInterval(timer)
  }, [items.length, interval])

  return (
    <div className={styles['carousel-container']}>
      {items.map((item, i) => (
        <div
          key={i}
          className={`${styles['carousel-item']} ${i === index ? styles.active : ''}`}
        >
          <img src={item.image} className={`${styles['carousel-image']}`} alt="" />
          <div className={styles['carousel-text-wrap']}>
            <div className={styles['carousel-text']}>{item.text}</div>
            {/* <div className={styles['carousel-author']}>{item.author}</div> */}
          </div>
        </div>
      ))}
    </div>
  )
}

export default FadeCarousel
